export default {
  "ORDER_WAIT_SHIP": "待發貨",
  "Men fashion": "男裝",
  "MyAccount_MyProfile_label_First": "名字",
  "MyAccount_MyShippingDetails_Phone": "電話號碼",
  "Page_not_found_message1": "很抱歉找不到該頁面",
  "Help": "幫助",
  "Sign in": "登錄",
  "Register": "註冊",
  "Category_sorting_Item": "選擇排序方式",
  "cart_clear": "清空購物車",
  "Payment & Delivery": "付款和送貨",
  "Send my feedback": "發送我的反饋",
  "MyAccount_MyProfile_Save": "保存更改",
  "Continue_billing": "繼續結算",
  "Categories": "分類",
  "Read and understand": "我已閱讀並理解",
  "Feel free to edit": "隨時編輯您的任何詳細信息，以便您的帳戶始終保持最新狀態",
  "Select payment method": "選擇支付方式",
  "Login_input_email": "您的電子郵件",
  "Login_input_first": "名字",
  "Account": "帳戶",
  "Create_Time_Asc": "創建時間升序",
  "concactus_label": "意見或問題",
  "Order_Grade": "訂單評分",
  "wishlist_empty_desc": "看起來您還沒有添加任何商品到購物袋中。開始購物吧！",
  "cartpreviewShipping_messageinfo": "您將收到發貨確認和到貨日期",
  "unsubscribe": "您可以隨時取消訂閱",
  "prompt": "提示",
  "MyAccount_MyProfile_yinsi_message": "在Brand name，我們非常重視隱私問題，並致力於保護用戶的個人數據。了解更多關於我們如何關心和使用您的個人數據的信息，請參閱",
  "About us": "關於我們",
  "or": "或者",
  "MyAccount_Order_History_All": "全部訂單",
  "What_We_Improve": "我們如何改進？",
  "MyAccount_ShippingDetails_title": "送貨詳情",
  "MyAccount_Order_History_Tabs2": "待支付",
  "Go_back_shopping": "返回購物",
  "Product": "產品",
  "Order summary": "訂單摘要",
  "payment_order_total": "訂單總額",
  "Departments": "法律聲明",
  "Download": "下載",
  "Your_Purchase_Order": "您的訂單",
  "Your_Account": "您的帳戶",
  "order_after_sales_list_null": "您目前沒有售後訂單",
  "All_After_sales_orders": "全部售後訂單",
  "Filters": "篩選",
  "search_results_not": "我們沒有找到與給定短語相關的結果",
  "ORDER_WAIT_RECEIPT": "待收貨",
  "ORDER_CLOSED": "已關閉",
  "Order_View_details": "查看詳情",
  "Subscribe_to_message": "了解即將推出的銷售和活動。獲得禮品和特別優惠！",
  "TaxFee": "稅費",
  "Apply": "應用",
  "Total_price": "總價",
  "Description": "描述",
  "Payment method": "付款方式",
  "Back": "返回",
  "Empty": "看起來您還沒有添加任何商品到購物袋中。開始購物以填滿它。",
  "After_sales": "售後",
  "Instruction3": "是的，我們知道",
  "MyAccount_MyShippingDetails_Last": "姓氏",
  "MyAccount_MyShippingDetails_City": "城市",
  "payment_order_discount": "訂單折扣",
  "MyAccount_Order": "訂單詳情",
  "ID_Name_Error": "請輸入您的身份證姓名",
  "Kidswear": "童裝",
  "Share your look": "分享你的造型",
  "Pay_Order": "支付訂單",
  "Reset_Password": "重置密碼",
  "MyAccount_MyProfile_label2_pass1": "當前密碼",
  "Create_Time_Desc": "創建時間降序",
  "Items": "商品",
  "Login_Register": "立即註冊",
  "Back to homepage": "返回首頁",
  "switch_CNY": "切換人民幣",
  "Successful placed order": "您已成功下單。您可以使用我們的交付狀態功能檢查訂單狀態。您將收到一封包含訂單詳細信息和跟踪鏈接的訂單確認電子郵件。",
  "MyAccount_MyProfile_yinsi_link": "隱私政策",
  "Order_Date": "訂單日期",
  "Allow order notifications": "允許訂單通知",
  "MyAccount_MyProfile_Tab1": "個人資料",
  "MyAccount_ShippingDetails_changeTitle": "更改地址",
  "ID_Number": "身份證號碼",
  "Order_after_sales_message": "詳情和售後訂單",
  "MyAccount_MyProfile_title2": "如果您想更改訪問您的帳戶的密碼，請輸入以下信息：",
  "Customer service": "客戶服務",
  "MyAccount_MyProfile_Update": "更新密碼",
  "choose_language": "選擇語言",
  "ORDER_REFUNDING": "退款中",
  "MyAccount_MyProfile_title1": "隨時編輯下面的任何詳細信息，以便您的帳戶始終保持最新狀態",
  "ORDER_WAIT_RATE": "待評價",
  "after_sales_refund_order": "訂單退款",
  "Who we are": "我們是誰",
  "Women fashion": "女裝",
  "Personal details": "個人資料",
  "Password": "密碼",
  "wishlist_empty_title": "您的購物袋為空",
  "Repeat_Password": "重複密碼",
  "cart_price": "小計",
  "Sort_by": "排序方式",
  "Customer Reviews": "客戶評價",
  "Continue to shipping": "繼續運輸",
  "payment_make_order": "下單",
  "save_order_review": "提交評價",
  "Save_Password": "保存密碼",
  "cart_empty_title": "您的購物車為空",
  "TopBar_help": "幫助與常見問題解答",
  "colseCookie": "我知道了",
  "Password_Changed": "密碼已成功更改。您現在可以返回主頁並登錄。",
  "Forgot Password Modal Email": "您用於登錄的電子郵件：",
  "MyAccount_Personal": "個人資料",
  "cartPreviewShipping": "便捷運輸",
  "ORDER_AFTER_SALE": "售後中",
  "Page_not_found": "頁面未找到",
  "Find out more": "了解更多",
  "Log into your account": "登錄您的帳戶",
  "Details_and_status_orders": "在線商店中檢查訂單的詳細信息和狀態。您還可以取消訂單或請求退貨。",
  "Order_to_be_paid_message": "待支付",
  "Guarantee": "保證",
  "Sections that interest you": "您感興趣的部分",
  "payment_post_tax": "郵費稅",
  "ORDER_PAID": "已支付",
  "concactus_label5": "稱呼",
  "Item": "商品",
  "Go_back": "返回",
  "more": "更多",
  "MyAccount": "我的帳戶",
  "payment_agree_1": "我同意",
  "total_items": "總件數",
  "shopping_go": "管理送貨地址",
  "ID_Type": "身份證類型",
  "after_sales_status": "售後狀態",
  "After_sales_apply": "申請售後",
  "Login": "登錄",
  "Quantity": "數量",
  "payment_post_fee": "郵費",
  "MyAccount_Log_out": "退出登錄",
  "Subtotal": "小計",
  "forgotPasswordConfirmation": "謝謝！如果使用 {0} 電子郵箱註冊了帳戶，則會在收件箱中找到包含密碼重置鏈接的消息。",
  "MyAccount_Order_History_Tabs1": "我的訂單",
  "concactus_img": "上傳圖片",
  "Done": "完成",
  "Info after order": "您可以使用之前定義的電子郵件和密碼登錄您的帳戶。在您的帳戶中，您可以編輯個人資料、查看交易歷史記錄、編輯訂閱通訊等。",
  "MyAccoubnt_Set_newsletter": "設置您的新聞通訊，我們每周會向您發送您選擇的部分的新產品和趨勢信息。",
  "Shipping_method": "運輸方式",
  "after_sales_refund": "退款金額",
  "After_sales_save": "保存售後信息",
  "go_order_history": "查看訂單歷史記錄",
  "contactus_message_placeholder": "請填寫您的評論或問題",
  "Login_Forgot_Password": "如果您無法記住密碼，可以重置密碼。",
  "show_more": "顯示更多",
  "MyAccount_MyProfile_label_email": "您的電子郵件",
  "MyAccount_MyProfile_label2_pass3": "重複密碼",
  "Products": "產品",
  "Review": "評價",
  "MyAccount_MyProfile_title3": "您當前的電子郵件地址為",
  "Category_found_Products": "找到的產品",
  "Match": "搭配",
  "Read_all_reviews": "閱讀所有評論",
  "Commercial information": "並同意通過電子郵件接收Brand name的個性化商業信息",
  "Change password your account": "如果您想更改訪問帳戶的密碼，請輸入以下信息",
  "ID_Name": "身份證姓名",
  "All": "全部",
  "Instruction2": "只需要保養說明？",
  "MyAccount_ShippingDetails_Add": "添加新地址",
  "MyAccount_MyShippingDetails_Zip": "郵政編碼",
  "go_pay_order": "去支付",
  "Thank_You_Inbox": "如果消息未到達收件箱，請嘗試使用您可能用於註冊的另一個電子郵件地址。",
  "Subscribe": "訂閱",
  "confirm_subscription": "我確認訂閱",
  "Login_input_Remember": "記住我",
  "Add to compare": "添加到比較",
  "Brand": "品牌",
  "Start_shopping": "開始購物",
  "Select shipping method": "選擇配送方式",
  "address CN": "地址在中國，當前貨幣必須為人民幣",
  "MyAccount_MyShippingDetails_State": "州/省",
  "Page_not_found_message2": "請返回或重新嘗試",
  "Go_to_checkout": "去結算",
  "See all results": "查看所有結果",
  "search_results_inputnull": "您還沒有搜索任何產品。",
  "subscribeToNewsletterModalContent": "訂閱通訊後，您將通過電子郵件收到來自 VSF 的特別優惠和信息。我們不會在任何時候出售或分發您的電子郵件給任何第三方。請參見我們的 {0}。",
  "Download all": "全部下載",
  "Login_input_last": "姓氏",
  "Amount": "金額",
  "ORDER_WAIT_PAYMENT": "待支付",
  "Order_After_sales": "訂單售後",
  "concattus_button": "提交",
  "Shipping_valid_required": "此項為必填項",
  "Price": "價格",
  "ID_Type_Error": "請選擇您的身份證類型",
  "Order_Status": "訂單狀態",
  "Payment methods": "付款方式",
  "MyAccount_MyProfile_Tab2": "更改密碼",
  "Show on page": "顯示在頁面上",
  "Edit": "編輯",
  "Change": "更改",
  "MyAccount_ShippingDetails_Update": "更新地址",
  "View": "查看",
  "Privacy": "隱私",
  "Enter_promo_code": "輸入優惠碼",
  "Discount": "折扣",
  "Delete": "刪除",
  "Wishlist": "心願單",
  "MyAccount_Order_History_Tabs3": "退貨",
  "Go_To_Order_review": "去評價",
  "Update personal data": "更新個人資料",
  "payment_agree_2": "條款和條件",
  "or fill the details below": "或填寫以下細節",
  "Contact details updated": "保持您的地址和聯繫方式更新。",
  "Login_Create": "創建帳戶",
  "Payment": "支付",
  "Billing": "賬單",
  "payment_insurance_tax": "保險稅",
  "Size guide": "尺碼指南",
  "Login_forgotten_password": "忘記密碼？",
  "Login_no_account": "還沒有帳戶？",
  "Privacy_Policy": "隱私政策",
  "BootomCookieTitle": "Cookie許可",
  "Use your personal data": "在Brand name，我們非常重視隱私問題，並致力於保護我們用戶的個人數據。了解有關我們如何關心和使用您的個人數據的更多信息，請參閱",
  "Review my order": "查看我的訂單",
  "BootomCookieLink": "了解更多",
  "hide": "隱藏",
  "MyAccount_ShippingDetails_message_title": "管理您想要的所有送貨地址（工作場所、家庭地址等），這樣您就不必在每個訂單中手動輸入送貨地址。",
  "Purchase terms": "購買條款",
  "Billing_address": "賬單地址",
  "Manage shipping addresses": "管理您想要的所有送貨地址（工作場所，家庭地址...）這樣您就不必在每個訂單中手動輸入送貨地址。",
  "login_logbtn": "登錄帳戶",
  "choose_currency": "選擇貨幣",
  "ORDER_REFUNDED": "已退款",
  "After_sales_form": "填寫售后表單",
  "add_To_Wishlist": "加入心願單",
  "search_results_inputnull2": "現在開始吧，我們會幫助您。",
  "Total": "總計",
  "Subscribe_to_newsletter": "訂閱通訊",
  "Shipping_valid_Phone": "請輸入有效的電話號碼",
  "concactus_label3": "標題",
  "Manage billing addresses": "管理所有希望的賬單地址（工作場所、家庭地址...）這樣您就不必在每個訂單中手動輸入賬單地址。",
  "Search_results_title": "搜尋結果",
  "payment_order_payment": "訂單支付",
  "after_sales_Id": "售后ID",
  "cart_title": "我的購物車",
  "Order_Detail": "訂單詳情",
  "concactus_label2": "商店鏈接",
  "Shipping_valid_length_min": "該字段至少應有{min}個字符",
  "Product suggestions": "產品建議",
  "Return_home": "返回首頁",
  "Quality in the details": "注重細節的品質",
  "Continue_to_payment": "繼續支付",
  "Feedback": "您的反饋對我們很重要。請告訴我們我們可以改進什麼。",
  "Go back to shop": "返回商店",
  "Back_to_home": "返回首頁",
  "Review_Content": "評價內容",
  "add_To_Cart": "加入購物車",
  "Read_reviews": "閱讀評論",
  "Instruction1": "保養方式",
  "Email_address": "電子郵件地址",
  "Category_Item_List": "切換列表視圖",
  "Same as shipping address": "與送貨地址相同",
  "Category_Item_Grid": "切換網格視圖",
  "ID_Number_Error": "請輸入您的身份證號碼",
  "concactus_label4": "聯繫郵件",
  "Additional_info": "附加信息",
  "add_shipping": "添加新的送貨地址",
  "Product_description": "Karissa V-Neck Tee採用半合身設計，適合各種身型。它緊貼曲線，遮蓋常見的“問題”區域，讓你自信地去健身房。還有驚艷的女士雞尾酒禮服和派對禮服。",
  "Login_create_account": "我要創建一個帳戶",
  "after_sales_Reason": "售后原因",
  "MyAccount_MyProfile_label_Last": "姓氏",
  "MyAccount_MyProfile_label2_pass2": "新密碼",
  "Save": "保存",
  "CartSliderTextBtn": "保存到稍後購買",
  "Color": "顏色",
  "Shipping_Tax": "運費稅",
  "Subscribe_to_success": "您已訂閱",
  "Enjoy your free account": "享受您的免費帳戶特權！",
  "cart_empty_desc": "看起來您還沒有添加任何商品到購物袋中。開始購物以填滿它。",
  "MyAccount_ShippingDetails_message_title2": "保持您的地址和聯繫方式更新。",
  "An_error_occured": "發生錯誤",
  "Country": "國家",
  "MyAccount_MyShippingDetails_First": "名字",
  "payment_insurance_fee": "保險費",
  "Home": "首頁",
  "Contact_us": "聯繫我們",
  "Cookies Policy": "Cookie政策",
  "Clear all": "清空所有",
  "Basket": "購物籃",
  "MyAccount_MyProfile_reqeatPassErrMsg": "新密碼不一致",
  "Your current email address is": "您當前的電子郵件地址為",
  "You currently have no orders": "您目前沒有訂單",
  "Login_input_password": "密碼",
  "Promo_code": "優惠碼",
  "order_count": "訂單數",
  "email_geshi_error": "請輸入有效的電子郵件地址",
  "your_email": "您的電子郵件",
  "email": "電子郵件",
  "you_have_subscribed": "您已訂閱",
  "cancel_Subscribe": "取消訂閱",
  "save_and_pay": "儲存並支付",
  "hasInsurance": "是否購買保險",
  "pleasePayType": "請選擇支付方式",
  "zhuanfa_toBePay": "轉給朋友代你支付",
  "linkCopied": "連結已複製，快去黏貼分享給朋友吧",
  "Links": "鏈接",
  "article_category": "文章分類",
  "wechat_code_login_message": "請使用微信掃描二維碼登錄",
  "wechat_code_login": "微信掃碼登錄",
  "Api_Update_success": "更新成功",
  "Please_Use_WeChat_login": "請使用微信登錄",
  "mobile_geshi_error": "請輸入有效的手機號",
  "Login_input_email_required": "請輸入郵箱",
  "article_null": "暫無文章",
  "Login_with_microsoft": "微軟登錄",
  "article_null_des": "您可以瀏覽其他分類的文章",
  "register_email": "郵箱註冊",
  "Login_tab_email": "郵箱登錄",
  "code.time": "{time}秒後重試",
  "Login_with_wechat": "微信登錄",
  "cat_items_null_des": "您可以瀏覽其他分類的商品",
  "Login_with_facebook": "facebook登錄",
  "Login_input_code": "驗證碼",
  "Login_input_mobile_required": "請輸入手機號",
  "Login_input_mobile": "您的手機號",
  "cat_items_null": "該分類下暫無商品",
  "Login_with_twitter": "twitter登錄",
  "mobile_code": "驗證碼",
  "register_mobile": "手機註冊",
  "Login_tab_mobile": "手機登錄",
  "Login_with_google": "google登錄",
  "OrderSku": "商品規格",
  "Order_logisticsNo": "物流單號",
  "order_shopping_firstname": "姓名",
  "Order_logisticsName": "物流公司",
  "ItemPrice": "商品金額",
  "inPayOrderAll": "待支付清單",
  "payPrice": "支付金額",
  "shipping_add_success": "收貨地址創建成功",
  "match_goods": "熱賣商品",
  "pay_code_refresh": "刷新支付碼",
  "pay_code_shixiao": "支付二維碼已失效",
  "concactus_title": "聯繫我們",
  "Search_items": "搜索",
  "WebAutoLang": "您當前的瀏覽器推薦語言是：{lang}，是否切換到該語言？",
  "Services_Name": "服務名稱",
  "Services_Price": "服務費用",
  "SwichLang": "切換語言",
  "Services_Description": "服務描述",
  "goodinfo_null": "暫無商品",
  "goodinfo_null_des": "您可以瀏覽其他分類的商品",
  "notYetUseCode": "未使用優惠碼",
  "guest_Login": "訪客登錄",
  "billing_and_shipping": "帳單和送貨地址一致",
  "select_coupon": "選擇優惠券",
  "select_gift": "選擇禮物",
  "currentUseCode": "已使用優惠碼",
  "shipping_refresh": "刷新列表",
  "Shipping_details": "收貨地址",
  "MyAccount_Newsletter": "訂閱",
  "MyAccount_Profile": "資料",
  "MyAccount_Wishlist": "願望清單",
  "See_all": "全部",
  "MyAccount_History": "訂單記錄",
  "bind_microsoft": "綁定微軟",
  "bind_twitter": "綁定twitter",
  "bind_facebook": "綁定facebook",
  "bind_wechat_code": "微信二維碼",
  "bind_wechat": "綁定微信",
  "bind_google": "綁定google",
  "Wishlist_Empty": "沒有心願單",
  "discount_post_fee": "郵費折扣",
  "ORDER_PART_PAID": "部分支付",
  "claimCouponeSuccess": "領取 {name} 成功",
  "discount_kou": "{discount}折",
  "claimCoupone": "領取",
  "cartPreviewSafety_messageinfo": "安全、快速的配送到您的地址",
  "Order_No": "訂單編號",
  "cartPreviewSafety": "安全配送",
  "Shipping": "配送",
  "MyAccount_MyShippingDetails_Street": "街道",
  "MyAccount_MyShippingDetails_HouseNumber": "門牌號碼",
  "Shipping_title": "收貨地址",
  "Offline_payment": "線下支付",
  "shopName": "店鋪名稱",
  "Social": "社交",
  "SERVICE": "服務",
  "onlineContact": "在線聯繫",
  "confirm": "確認",
  "closeOrder": "取消訂單",
  "closeOrderContext": "您確定要取消訂單嗎？",
  "Message_Read": "已讀",
  "close.order.success": "訂單取消成功",
  "shippingAddress": "詳細地址",
  "Message": "消息",
  "Message_Empty_Title": "您的消息是空的",
  "MyAccount_Message": "消息",
  "Message_Empty": "暫無消息",
  "payment_order_note": "訂單備註",
  "go_to_see_prepid": "點這裡去查看未支付訂單",
  "operate": "操作",
  "removeCartItemContext": "您確定要移除{title}嗎？",
  "shippingItemQty": "配送數量",
  "removeCartItem": "移除商品",
  "shippingInfo": "配送信息",
  "Distributor_success": "已經成功為分銷商",
  "Distributor_apply": "申請成為分銷商",
  "Distributor_Details": "分銷商",
  "DistributorSataus": "狀態",
  "Distributor_Details_Empty": "暫無分銷商",
  "distributor.status.4": "已作廢",
  "distributor.status.1": "未審核",
  "Distributor_copy_url": "複製分銷連結",
  "Order_Time": "下單時間",
  "Order_User": "下單人",
  "Distributor_copy_success": "複製成功",
  "distributor.status.3": "已結算",
  "MyAccount_Distributor": "分銷商",
  "MyAccoubnt_Set_Distributor": "申請成為分銷商",
  "distributor.status.2": "待結算",
  "DistributorAmount": "佣金",
  "Distributor_shenheshibai": "分銷商審核未通過",
  "Distributor_shenhezhong": "分銷商審核中",
  "Distributor_Order_Empty": "暫無分銷訂單",
  "NE": "尼日爾",
  "DJ": "吉布地",
  "KP": "朝鮮",
  "US": "美國",
  "LC": "聖盧西亞",
  "NL": "荷蘭",
  "CD": "剛果民主共和國",
  "IS": "冰島",
  "MA": "摩洛哥",
  "GH": "加納",
  "KR": "韓國",
  "MK": "馬其頓",
  "HT": "海地",
  "PF": "法屬波利尼西亞",
  "GA": "加蓬",
  "TD": "乍得",
  "LB": "黎巴嫩",
  "CG": "剛果",
  "KG": "吉爾吉斯斯坦",
  "TA": "特里斯坦-達庫尼亞",
  "KW": "科威特",
  "TL": "東帝汶",
  "IN": "印度",
  "NO": "挪威",
  "NG": "尼日利亞",
  "AQ": "南極洲",
  "LY": "利比亞",
  "NI": "尼加拉瓜",
  "TT": "特立尼達和多巴哥",
  "HM": "赫德和麥克唐納群島",
  "PY": "巴拉圭",
  "BA": "波斯尼亞和黑塞哥維那",
  "JP": "日本",
  "MD": "摩爾多瓦",
  "MT": "馬爾他",
  "RE": "留尼旺島",
  "UG": "烏干達",
  "SB": "所羅門群島",
  "SL": "塞拉利昂",
  "CV": "佛得角",
  "SD": "蘇丹",
  "FO": "法羅群島",
  "ZA": "南非",
  "TR": "土耳其",
  "FK": "福克蘭群島",
  "PA": "巴拿馬",
  "GF": "法屬圭亞那",
  "TJ": "塔吉克斯坦",
  "NC": "新喀裡多尼亞",
  "PM": "聖皮埃爾和密克隆群島",
  "NU": "紐埃",
  "AO": "安哥拉",
  "VN": "越南",
  "GN": "幾內亞",
  "MW": "馬拉維",
  "BY": "白俄羅斯",
  "IM": "曼島",
  "BI": "布隆迪",
  "BS": "巴哈馬",
  "CK": "庫克群島",
  "MH": "馬紹爾群島",
  "CR": "哥斯達黎加",
  "HK": "中國香港特別行政區",
  "AD": "安道爾",
  "BN": "文萊",
  "SN": "塞內加爾",
  "AE": "阿拉伯聯合酋長國",
  "GI": "直布羅陀",
  "CA": "加拿大",
  "AX": "奧蘭群島",
  "UY": "烏拉圭",
  "WF": "瓦利斯和福圖納",
  "GM": "岡比亞",
  "SO": "索馬裡",
  "RU": "俄羅斯",
  "PL": "波蘭",
  "FM": "密克羅尼西亞",
  "ET": "埃塞俄比亞",
  "EE": "愛沙尼亞",
  "SK": "斯洛伐克",
  "AS": "美屬薩摩亞",
  "ZM": "贊比亞",
  "AL": "阿爾巴尼亞",
  "AT": "奧地利",
  "VA": "梵蒂岡",
  "TW": "中國台灣",
  "BD": "孟加拉國",
  "AR": "阿根廷",
  "EH": "西撒哈拉",
  "MO": "中國澳門特別行政區",
  "MV": "馬爾代夫",
  "GU": "關島",
  "AW": "阿魯巴",
  "AI": "安圭拉",
  "CL": "智利",
  "IL": "以色列",
  "GD": "格林納達",
  "WS": "薩摩亞",
  "SE": "瑞典",
  "GP": "瓜德羅普",
  "YE": "葉門",
  "GT": "危地馬拉",
  "BG": "保加利亞",
  "SJ": "斯瓦爾巴和揚馬廷",
  "CO": "哥倫比亞",
  "LS": "萊索托",
  "LV": "拉脫維亞",
  "UM": "美屬外島",
  "MX": "墨西哥",
  "DO": "多明尼加共和國",
  "PE": "秘魯",
  "HN": "洪都拉斯",
  "TC": "特克斯和凱科斯群島",
  "VI": "維爾京群島，美屬",
  "FJ": "斐濟",
  "MP": "北馬里亞納群島",
  "AC": "阿森松島",
  "NA": "納米比亞",
  "SZ": "斯威士蘭",
  "RW": "盧旺達",
  "BH": "巴林",
  "KN": "聖基茨和尼維斯",
  "TN": "突尼斯",
  "AF": "阿富汗",
  "VG": "維爾京群島，英屬",
  "KE": "肯尼亞",
  "PK": "巴基斯坦",
  "GL": "格陵蘭",
  "SY": "敘利亞",
  "CU": "古巴",
  "RS": "塞爾維亞",
  "BF": "布基納法索",
  "BM": "百慕達",
  "BZ": "貝裡斯",
  "SV": "薩爾瓦多",
  "CN": "中國",
  "MF": "聖馬丁",
  "NF": "諾福克",
  "MZ": "莫桑比克",
  "LU": "盧森堡",
  "TO": "湯加",
  "GR": "希臘",
  "SI": "斯洛文尼亞",
  "PW": "帛琉群島",
  "TZ": "坦桑尼亞",
  "IR": "伊朗",
  "GG": "格恩西島",
  "SM": "聖馬力諾",
  "TF": "法屬南部領土",
  "PS": "巴勒斯坦",
  "SC": "塞舌爾",
  "BT": "不丹",
  "JM": "牙買加",
  "BR": "巴西",
  "CH": "瑞士",
  "SH": "聖赫勒拿",
  "HU": "匈牙利",
  "TM": "土庫曼斯坦",
  "LT": "立陶宛",
  "MC": "摩納哥",
  "LI": "列支敦士登",
  "LR": "利比里亞",
  "GE": "喬治亞",
  "SA": "沙烏地阿拉伯",
  "GB": "英國",
  "VE": "委內瑞拉",
  "MU": "毛裏求斯",
  "HR": "克羅地亞",
  "SR": "蘇里南",
  "CM": "喀麥隆",
  "IQ": "伊拉克",
  "BO": "玻利維亞",
  "MN": "蒙古",
  "DZ": "阿爾及利亞",
  "TK": "托克勞",
  "MG": "馬達加斯加",
  "YT": "馬約特島",
  "CC": "科科斯群島",
  "LA": "老撾",
  "PT": "葡萄牙",
  "QA": "卡塔爾",
  "AN": "荷屬安地列斯",
  "PN": "皮特凱恩",
  "ES": "西班牙",
  "VC": "聖文森特和格林納丁斯",
  "AU": "澳大利亞",
  "CX": "聖誕島",
  "KM": "科摩羅",
  "MR": "毛里塔尼亞",
  "FR": "法國",
  "SG": "新加坡",
  "BV": "布韋島",
  "PH": "菲律賓",
  "CY": "塞浦路斯",
  "TV": "圖瓦盧",
  "CF": "中非共和國",
  "EC": "厄瓜多爾",
  "GW": "幾內亞比紹",
  "IE": "愛爾蘭",
  "LK": "斯里蘭卡",
  "ER": "厄立特里亞",
  "GQ": "赤道幾內亞",
  "NP": "尼泊爾",
  "BE": "比利時",
  "GY": "圭亞那",
  "DK": "丹麥",
  "MQ": "馬提尼克",
  "UZ": "烏茲別克斯坦",
  "CI": "科特迪瓦",
  "ID": "印尼",
  "BJ": "貝寧",
  "ST": "聖多美和普林西比",
  "KH": "柬埔寨",
  "KZ": "哈薩克斯坦",
  "MS": "蒙特塞拉特",
  "TH": "泰國",
  "FI": "芬蘭",
  "ML": "馬里",
  "AM": "亞美尼亞",
  "IT": "義大利",
  "NR": "諾魯",
  "PG": "巴布亞新幾內亞",
  "ZW": "辛巴威",
  "JO": "約旦",
  "OM": "阿曼",
  "ME": "黑山",
  "JE": "澤西島",
  "NZ": "新西蘭",
  "VU": "瓦努阿圖",
  "DE": "德國",
  "CZ": "捷克共和國",
  "DM": "多米尼加",
  "KY": "開曼群島",
  "BW": "博茨瓦納",
  "RO": "羅馬尼亞",
  "PR": "波多黎各",
  "AZ": "阿塞拜疆",
  "IO": "英屬印度洋領地",
  "UA": "烏克蘭",
  "TG": "多哥",
  "MY": "馬來西亞",
  "AG": "安提瓜島和巴布達",
  "EG": "埃及",
  "GS": "南喬治亞和南桑威奇群島",
  "MM": "緬甸",
  "BB": "巴巴多斯島",
  "KI": "基裏巴斯",
  "All_Country": "全部",
  "post_state_country": "配送費： {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "配送到",
  "ShippingFee": "配送費",
  "reviewOutOf": "{rating} 星，共 5 星",
  "product.pifa.label": "買 {startnum} - {endnum}件",
  "product.pifa.type.1": "折扣",
  "Write_a_review": "寫評論",
  "BasedOnTotalReviews": "基於 {total} 條評論",
  "product.wholesale": "批發價",
  "reviewMostRecent": "最新評論",
  "product.pifa.type.2": "單價",
  "product.num.danwei": "個",
  "good.shoppingDateLabel": "發貨時間",
  "good.shippingPeriod": "天內發貨",
  "emailError": "郵箱格式錯誤",
  "addressNote": "備註",
  "Concactus": "聯繫",
  "addressMessage": "請確保您的地址正確無誤。結帳後我們無法更改地址。",
  "showOrderSummary": "訂單摘要",
  "payment_method": "支付方式",
  "emailNotNullError": "郵箱不能為空",
  "orderCreateLoading": "訂單創建中...",
  "emailNote": "聯繫",
  "emailMessage": "請確保您的郵箱地址正確無誤。我們將向您發送訂單確認郵件。",
  "payment_method_message": "所有交易都是安全和加密的。",
  "go_buy_goods": "繼續購物",
  "tap_cancel_order": "點擊這裡取消訂單",
  "order_review": "訂單評價",
  "Add_new_address": "添加新地址",
  "promo_code_type_3": "滿送劵",
  "IdCardNotNull": "請填寫實名信息",
  "UploadVideo": "上傳視頻",
  "video": "視頻",
  "UploadImage": "上傳圖片",
  "uploadImageing": "上傳中...",
  "BillingInfoNotNull": "賬單信息不完整",
  "promo_code_type_2": "代金券",
  "UploadError": "上傳失敗",
  "promo_code_type_4": "減運費劵",
  "image": "圖片",
  "paymentMethodNotNull": "請選擇支付方式",
  "promo_code_type_1": "折扣劵",
  "shippingInfoNotNull": "配送信息不完整",
  "reviewDetail": "評價詳情",
  "DeliveryCountry": "配送區域",
  "prompt_error": "提示錯誤",
  "save_review_success": "評價成功",
  "ORDER_COMPLETED": "已完成",
  "crate_after_sales": "創建售後",
  "Thank_You_Order": "感謝您的訂單！",
  "Thank_You_Order_sub": "稍後我們將開始處理您的訂單，您將收到一封包含關於訂單處理的電子郵件。",
  "BootomCookieContext": "這個網站使用 cookies 來幫助網站正常運作並幫助我們了解如何與它互動。我們使用這些 cookies 來為您提供更好的個性化的使用者體驗。如果您繼續使用本網站，我們將認為您同意使用cookies。",
  "order_reivice_message": "您確定已經收到貨物了嗎？",
  "order_reivice_btn": "確認收貨",
  "order_reivice_label": "訂單收貨",
  "order_reivice_success": "確認收貨成功",
  "collpase_show": "查看更多",
  "collpase_hide": "收起",
  "CouponCode": "優惠碼",
  "wechatPayScannerCode": "請使用微信掃碼支付",
  "processing": "售後處理中",
  "finished": "售後已完成",
  "login.showPrice": "登入後查看價格",
  "After_Sales_Unknown": "售後狀態未知",
  "order_payment_list_null": "沒有待支付的訂單",
  "Cancel": "取消",
  "thankyou_concat": "如有任何問題請與我們聯繫"
}